import { Box, Card, Icon, Text, Title } from '@nimbus-ds/components';
import { CodeIcon } from '@nimbus-ds/icons';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';

function DevelopmentCard() {
  const t = useTranslationBilling('checkout.plansAndSubscriptions');

  return (
    <Card>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="3"
      >
        <Icon color="neutral-textHigh" source={<CodeIcon size={42} />} />
        <Title as="h2">{t('developmentCard.title')}</Title>
        <Text>{t('developmentCard.message')}</Text>
      </Box>
    </Card>
  );
}

export default DevelopmentCard;
